import * as DT from '.';

export const changeTablePage = (actionType: string, pageNumber: number) => ({
  type: actionType,
  payload: { pageNumber: pageNumber + 1 } as DT.TablePageChangedPayload,
});

export const changeTableSizePage = (actionType: string, pageSize: number) => ({
  type: actionType,
  payload: { pageSize } as DT.TablePageSizeChangedPayload,
});

export const changeTableSorting = (
  actionType: string,
  sort: DT.SortCriteria[]
) => ({
  type: actionType,
  payload: { sort } as DT.SortCriteriaPayload,
});

export const updateTableItemSelection = <T extends {}>(
  actionType: string,
  item: T
) => ({
  type: actionType,
  payload: { item } as DT.TableToggleItemPayload,
});
